export const critStyles = ['body, html { margin: 0; padding: 0}', `#hs-nav-v4 nav, #hs-nav-v4 div, #hs-nav-v4 span, #hs-nav-v4 ul, #hs-nav-v4 li, #hs-nav-v4 a, #hs-nav-v4 svg, #hs-nav-v4 img, #hs-nav-v4 title, #hs-nav-v4 input {
  -webkit-font-smoothing: antialiased;
  font-family: var(--uicomponents-font-family, "Lexend Deca", Helvetica, Arial, sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: rgb(51, 71, 91);
  line-height: 1.5rem;
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  transition: none 0s ease 0s;
  text-shadow: transparent 0 0 1px;
  box-sizing: border-box;
}`, `.space-sword--editor #placeholder-vertical-nav {
  display: none
}`, `.space-sword--editor .page, .space-sword--editor .app {
  width: auto;
  margin-left: 0;
}`];
export const hublessStyles = [`
  #placeholder-vertical-nav {
    display: none;
  }
  `, `
  .app, .page {
    width: auto !important;
    margin-left: auto !important;
  }
`];
export const CRITICAL_CSS_ID = 'hs-nav-critical-css';
export default function loadCriticalCSS(args) {
  const newStyles = document.createElement('style');
  newStyles.id = CRITICAL_CSS_ID;
  newStyles.type = 'text/css';
  document.head.appendChild(newStyles);
  const criticalCSS = [...critStyles];
  if (args && args.isHubless) {
    criticalCSS.push(...hublessStyles);
  }
  criticalCSS.forEach(ruleSet => {
    newStyles.sheet.insertRule(ruleSet, newStyles.sheet.cssRules.length);
  });
}